<div class="wrapper">
  <div class="heading text-type-2 mb-[40px]">
    Create an offsite test
  </div>
  <div class="form-section`">
    <app-dropdown
      (checkForErrors)="checkForErrors($event)"
      [enableDetailedOptionView]="true"
      [enableSearch]="true"
      [error]="errorMessages['bidItem']"
      [options]="bidItemOptions"
      [parentFormGroup]="form"
      class="w-full mb-[20px]"
      controlName="bidItem"
      label="bid Item"
      placeholder="Select"
      />
    <app-dropdown
      (checkForErrors)="checkForErrors($event)"
      [error]="errorMessages['testName']"
      [options]="testNameOptions"
      [parentFormGroup]="form"
      class="w-full mb-[20px]"
      controlName="testName"
      label="Test Name"
      placeholder="Select"
      />
    <app-dropdown
      (checkForErrors)="checkForErrors($event)"
      [error]="errorMessages['labName']"
      [options]="labNameOptions"
      [parentFormGroup]="form"
      class="w-full mb-[20px]"
      controlName="labName"
      label="Lab Name"
      placeholder="Select"
      />
    <app-date-picker
      (checkForErrors)="checkForErrors($event)"
      [error]="errorMessages['date']"
      [parentFormGroup]="form"
      class="w-full mb-[20px]"
      controlName="date"
      label="Choose a date"
      />
    <app-multiple-time-select
      (checkForErrors)="checkForErrors($event)"
      [error]="errorMessages['time']"
      [parentFormGroup]="form"
      class="w-full mb-[20px]"
      controlName="time"
      label="time"
      />
    @if (displayCommentSection) {
      <app-text-area
        (checkForErrors)="checkForErrors($event)"
        [error]="errorMessages['comments']"
        [parentFormGroup]="form"
        class="w-full mb-[40px]"
        controlName="comments"
        label="comments"
        />
    }
    @if (showLocationSection()) {
      <app-location-section
        (onDelete)="deleteLocation()"
        [latitude]="form?.controls?.latitude?.value"
        [longitude]="form?.controls?.longitude?.value"
        class="location-section mb-[40px]"
        />
    }
    @if (mediaFiles?.length) {
      <app-pictures-section
        (onDelete)="deletePicture($event)"
        [pictures]="mediaFiles"
        class="pictures-section mb-[40px]"
        />
    }
  </div>
</div>
